import initService from './init-service'
import commonService from "./common";

let sort = "IMSI asc";
let expiry = initService.getExpiryData();

const searchDashboardService = {

  getSimType() {
    // let cache = [{simtype:"Combo"},{simtype:"pSim"},{simtype:"eSim"}];
    // return Promise.resolve(cache);

    let param = `IOT_GetSimTypes`;
    return commonService.commonAPI(param)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },

  getStateType() {
    let param = `IOT_GetStateList`;
    return commonService.commonAPI(param)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },

  getCustomerType() {
    let param = `IOT_GetCustomerList`;
    return commonService.commonAPI(param)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },

  getSearchResult(start, length, filterSearch) {
    let {fStartIMSI, fEndIMSI, fSimType, fIccid, fMsisdn, fState} = filterSearch;
    let filter = encodeURIComponent(`${fStartIMSI},${fEndIMSI},${fSimType},${fIccid},${fMsisdn},${fState}`);
    // console.log(filter);
    sort=encodeURIComponent(sort);
    let param = `IOT_GetSimSearchResultsPage&sort=${sort}&start=${start}&length=${length}&filter=${filter}&_=${expiry}`;
    return commonService.commonAPI(param)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },

  getLookupSubscriberByIMSI(imsi='',msisdn='',iccid='') {
    let param = `LookupSubscriber`;
    if (imsi!=='') param = param+`&imsi=${imsi}`;
    if (msisdn!=='') param = param+`&msisdn=${msisdn}`;
    if (iccid!=='') param = param+`&iccid=${iccid}`;
    return commonService.commonAPI(param)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },

  getSimUsageByIMSI(imsi) {
    let param = `IOT_GetSimUsage&period=monthly&imsi=${imsi}&nocache=1`;
    return commonService.commonAPI(param)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },

  getSmsUsageByIMSI(imsi) {
    let param = `IOT_GetSmsUsage&period=monthly&imsi=${imsi}&nocache=1`;
    return commonService.commonAPI(param)
        .then(response => response.data.message)
        .catch(error => console.error(error))
  },

  getSearchResultByFilter(startImsi, endImsi, simType, iccid, msisdn, state, start, length, sort) {
    let filter = encodeURIComponent(`${startImsi},${endImsi},${simType},${iccid},${msisdn},${state}`);
    let param = `IOT_GetSimSearchResultsPage&sort=${sort}&start=${start}&length=${length}&filter=${filter}&_=${expiry}`;
    return commonService.commonAPI(param)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },

  getViewMap(imsi) {
    let param = `IOT_ViewMapDataByImsi&imsi=${imsi}&period=monthly`;
    return commonService.commonAPI(param)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },

  sendSMS(sender, receiver, content) {
    let param = `IOT_SendSmsMessage&to=${receiver}&from=${sender}&body=${content}`;
    return commonService.commonAPI(param)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },

  getHLRInfo(imsi) {
    let param = `IOT_GetHlrInfo&imsi=${imsi}`;
    return commonService.commonAPI(param)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },

  getHSSInfo(imsi) {
    let param = `IOT_GetHssInfo&imsi=${imsi}`;
    return commonService.commonAPI(param)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },

  getSessionData(imsi) {
    let param = `IOT_GetSessionData&imsi=${imsi}&period=monthly`;
    return commonService.commonAPI(param)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },

  getSMSActivity(imsi) {
    let param = `IOT_GetSmsInbox&imsi=${imsi}&maxrecords=100`;
    return commonService.commonAPI(param)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },

  getHSSProfile(imsi) {
    let param = `GetHssProfile&imsi=${imsi}`;
    return commonService.commonAPI(param)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },

  getHSSProfileSelectOption() {
    let param = `GetHssProfiles`;
    return commonService.commonAPI(param)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },

  getHlrProfileSelectOption() {
    let param = `getHlrProfiles`;
    return commonService.commonAPI(param)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },

  getDataBucketList(filter) {
    let param = `IOT_GetDataBucketList&filter=${filter},default`;
    return commonService.commonAPI(param)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },

  getWatchDogs(imsi) {
    let param = `IOT_GetWatchdogs&imsi=${imsi}`;
    return commonService.commonAPI(param)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },
};

export default searchDashboardService;
